import {VIEW_STATE} from "../constants";

const CHANGE_VIEW_STATE = 'CHANGE_VIEW_STATE';

function changeViewState(nextViewState) {
  return {
    type: CHANGE_VIEW_STATE,
    payload: nextViewState
  };
}

export {
  changeViewState
}

const initialState = VIEW_STATE.MARKET;

const ACTION_HANDLERS = {
  [CHANGE_VIEW_STATE]: (state, action) => action.payload
};


export default function viewStateReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state
}


// WEBPACK FOOTER //
// ./src/store/viewState.js